import { Tab, Nav } from "react-bootstrap";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import KycDetails from "./KycDetails";
import BankDetails from "./BankDetails";
import General from "./General";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { updateCustomerAction, getCustomerByIdAction, loadingToggleAction } from "../../../store/actions/customer/CustomerActions";
import ShimmerLoader from "../../pages/ShimmerLoader/ShimmerLoader";
import PersonalDetails from "./PersonalDetails";

const ViewCustomerDetails = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, customerById } = useSelector((state) => state.customer);

  useEffect(() => {
    if (!id) {
      navigate("/customers");
      return;
    }
    dispatch(getCustomerByIdAction(id, navigate));
  }, [dispatch, id, navigate]);

  return (
    <>
      {loading && <ShimmerLoader width='95%' height='20%' count={4} />}
      {!loading && (
        <>
          <General customerById={customerById} />
          <Tab.Container defaultActiveKey='PersonalDetails'>
            <Nav as='ul' className='nav nav-tabs'>
              <Nav.Item as='li' i className='nav-item'>
                <Nav.Link to='#PersonalDetails' eventKey='PersonalDetails'>
                  Personal Details
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as='li' className='nav-item'>
                <Nav.Link to='#BankDetails' eventKey='BankDetails'>
                  Bank Details
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as='li' className='nav-item'>
                <Nav.Link to='#KYCDetails' eventKey='KYCDetails'>
                  KYC Details
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane id='PersonalDetails' eventKey='PersonalDetails'>
                <PersonalDetails customerById={customerById} />
              </Tab.Pane>
              <Tab.Pane id='BankDetails' eventKey='BankDetails'>
                <BankDetails customerById={customerById} />
              </Tab.Pane>
              <Tab.Pane id='KYCDetails' eventKey='KYCDetails'>
                <KycDetails customerById={customerById} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </>
      )}
    </>
  );
};

export default ViewCustomerDetails;
